import React, { Component } from 'react';
import { connect } from 'react-redux';
import TradingViewWidget, { Themes } from 'react-tradingview-widget';
import './chart.css';

class TradingView extends Component {
  render() {
    // let height = this.props.offers.length > 0 || this.props.demand.length > 0 ? '316px' : '476px';
    let height = '476px'
    return (
      <div className="row">
        <div className='chartdiv'>
          {/* */
          <TradingViewWidget
            symbol={this.props.text}
            theme={Themes.DARK}
            interval={'1'}
            allow_symbol_change={false}
            show_popup_button={false}
            save_image={false}
            hide_legend={true}
            locale="en"
            isTransparent={true}
            withdateranges={true}
            autosize
          /> /**/}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  let {denomination,asset} = state.ui_marketplace.market;

  if(denomination === "WAV") denomination = "WAVES"
  if(asset === "WAV") asset = "WAVES"

  let text = `${asset}${denomination}`;
  if(!text.includes('DAI')) text = `BINANCE:${asset}${denomination}`
  return {
    text,
    offers:state.orderbook.offers,
    demand:state.orderbook.demand
  };
}

export default connect(mapStateToProps,{})(TradingView);
